/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Detail_Screenshot_PrevInputs */

const en_directory_detail_screenshot_prev = /** @type {(inputs: Directory_Detail_Screenshot_PrevInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Previous screenshot`)
};

const zh_directory_detail_screenshot_prev = /** @type {(inputs: Directory_Detail_Screenshot_PrevInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`上一张截图`)
};

/**
* | output |
* | --- |
* | "Previous screenshot" |
*
* @param {Directory_Detail_Screenshot_PrevInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_detail_screenshot_prev = /** @type {((inputs?: Directory_Detail_Screenshot_PrevInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Detail_Screenshot_PrevInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_detail_screenshot_prev(inputs)
	return zh_directory_detail_screenshot_prev(inputs)
});
export { directory_detail_screenshot_prev as "directory.detail.screenshot_prev" }